import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { CSearchProCountListItem } from '@/components/modules/pages/consultantSearch/List/CSearchProCountListItem';
/**
 * コンサルタントの各種件数をリスト表示するコンポーネント
 * @constructor
 */
export const CSearchProCountList = (props) => {
    const { className = '', experienceCount, id, isDisableLink, isNestedLink, keyword = '', onClickSolutionLink, projectCareersCount, solutionLink, solutionsCount, } = props;
    // プロジェクト事例のリンク押下時に参照するdata属性
    const solutionRouterLinkAttributes = useMemo(() => ({
        dataAttributes: {
            'data-id': id.toString(),
            'data-keyword': keyword,
        },
    }), [id, keyword]);
    // 件数表示コンポーネント共通のクラス
    const { itemClassName, unitWithTextClassNames } = useMemo(() => ({
        itemClassName: clsx('pr-20 pl-20 first:pl-0 last:pr-0 pt-4 pb-4', 'border-solid border-gray-300 border-l-0 border-t-0 border-b-0 border-r-1 last:border-r-0'),
        unitWithTextClassNames: {
            main: clsx('transition', !isDisableLink && 'group-hover:text-link group-hover:underline'),
        },
    }), [isDisableLink]);
    return (_jsxs("div", Object.assign({ className: clsx('flex', className) }, { children: [experienceCount > 0 && (_jsx(CSearchProCountListItem, { className: itemClassName, linkClassName: 'group', mainText: experienceCount, noLinkElement: 'div', title: 'コンサル歴', unitText: '年' })), _jsx(CSearchProCountListItem, { className: itemClassName, isNestedLink: isNestedLink, linkClassName: 'group', mainText: solutionsCount, noLinkElement: isDisableLink ? 'div' : undefined, onClick: onClickSolutionLink, onClickNoLink: onClickSolutionLink, routerLinkAttributes: solutionRouterLinkAttributes, title: '事例掲載数', to: solutionLink, unitText: '件', unitWithTextClassNames: unitWithTextClassNames }), _jsx(CSearchProCountListItem, { className: itemClassName, linkClassName: 'group', mainText: projectCareersCount, noLinkElement: 'div', title: '実績登録件数', unitText: '件' })] })));
};
